import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddSubjectAssistPhone from "../../../containers/admin/subject-assist-phones/models/add-subject-assist-phone";
import SearchBar from "../../../containers/admin/subject-assist-phones/searchbar";
import SubjectAssistPhonesTable from "../../../containers/admin/subject-assist-phones/table";
import { getAllSubjectAssistPhonesRequest } from "../../../modules/admin-modules/subject-assist-phones/Actions";

const SubjectAssistPhones = () => {
  const dispatch = useDispatch();
  const subjectAssistPhones = useSelector((state) => state.subjectAssistPhones.subjectAssistPhones);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllSubjectAssistPhonesRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        subjectAssistPhones={subjectAssistPhones}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <SubjectAssistPhonesTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddSubjectAssistPhone
        key={`subject-assist-phone-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SubjectAssistPhones;

